var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMarkedMulticolor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 18,
    viewBox: "0 0 14 18",
    width: 14,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-3 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h20v20h-20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.6875 1.66666667c.4340278 0 .8029516.15190952 1.1067714.45572857.3038191.30381905.4557286.67274286.4557286 1.10677143v15.10416663l-6.25-3.6458333-6.25 3.6458333v-15.10416663c0-.43402778.15190952-.80295159.45572857-1.10677143.30381905-.30381905.67274286-.45572857 1.10677143-.45572857zm0 13.93226193v-12.17452384c0-.13020793-.065104-.1953119-.1953119-.1953119h-8.98438096c-.13020793 0-.1953119.06510397-.1953119.1953119v12.17452384l4.6875-2.734381z",
    fill: "#b6e0fe"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMarkedMulticolor);
export default __webpack_public_path__ + "static/media/icon-marked-multicolor.7a37e9f3.svg";
export { ForwardRef as ReactComponent };